<template>
  <div class="flex-center">
    <showcase-new-dialog :state="createState" />
    <v-btn v-if="selected.length" color="error" class="mr-2" @click="onRemove" depressed>
      <v-icon left>delete</v-icon>Xóa
    </v-btn>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ShowcaseNewDialog from '@/modules/showcase/ShowcaseNewDialog.vue'
export default {
  components: {
    ShowcaseNewDialog
  },
  props: {
    disabled: Boolean,
    selected: { type: Array, default: () => [] }
  },
  data() {
    return {
      createState: false,
      sending: null
    }
  },
  computed: {
    ...mapState('showcase', ['showcases'])
  },
  methods: {
    ...mapActions('showcases', ['removeShowcases', 'updateShowcases']),
    onRemove() {
      this.$dialog.confirm({
        title: 'Xóa Niên Khóa',
        text: 'Bạn Có chắc muốn xóa niến khóa này?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeShowcases(this.selected)
        }
      })
    }
  }
}
</script>
